import './CouponsDataGrid.css'

import moment from 'moment'
import React, { useCallback, useMemo } from 'react'
import { Button } from 'react-bootstrap'

import { DataGrid } from '../../../Components/DataGrid/DataGrid'
import { couponTypes } from './consts'

const getValueSign = type => {
  if (type === couponTypes.PERCENTAGE) return '%'
  return '$'
}
export const CouponsDataGrid = ({ coupons, onClickEdit, onClickDelete, setSelectedCoupons, loading }) => {
  // Column definitions for the coupons grid
  const columnDefs = useMemo(
    () => [
      {
        headerName: 'Family Name',
        field: 'familyName',
        width: 80,
      },
      {
        headerName: 'Code',
        field: 'code',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Type',
        field: 'type',
        sortable: true,
        filter: true,
        hide: true,
        valueFormatter: params => {
          if (params.value === couponTypes.PERCENTAGE) return 'Percentage'
          if (params.value === couponTypes.FIXED) return 'Fixed Amount'
          return params.value
        },
      },
      {
        headerName: 'Value',
        field: 'value',
        sortable: true,
        filter: true,
        valueFormatter: params => {
          if (params.value !== undefined) {
            const type = params.data.type
            const sign = getValueSign(type)
            return `${params.value}${sign}`
          }
          return ''
        },
      },
      {
        headerName: 'Country',
        field: 'country',
        sortable: true,
        filter: true,
        valueFormatter: params => {
          if (params.value) {
            return Array.isArray(params.value) ? params.value.join(', ') : params.value
          }
          return ''
        },
      },
      {
        headerName: 'Min Payment',
        field: 'minPayment',
        sortable: true,
        filter: true,
        hide: true,
        valueFormatter: params => {
          if (params.value !== undefined) {
            return `${params.value}₪`
          }
          return ''
        },
      },
      {
        headerName: 'Limited Uses',
        field: 'limitedUses',
        sortable: true,
        filter: true,
        hide: true,
        type: 'numericColumn',
      },
      {
        headerName: 'Limited Uses Per User',
        field: 'limitedUsesForUser',
        sortable: true,
        filter: true,
        hide: true,
        type: 'numericColumn',
      },
      {
        headerName: 'Times Used',
        field: 'timesUsed',
        sortable: true,
        filter: true,
        type: 'numericColumn',
      },
      {
        headerName: 'Total Payments',
        field: 'totalFinalPayments',
        sortable: true,
        filter: true,
        type: 'numericColumn',
        valueFormatter: params => {
          if (params.value !== undefined) {
            return `${params.value}₪`
          }
          return ''
        },
      },
      {
        headerName: 'Shipping Method',
        field: 'shippingMethod',
        sortable: true,
        filter: true,
        hide: true,
        valueFormatter: params => {
          if (params.value === 'all') return 'All Methods'
          return params.value
        },
      },
      {
        headerName: 'Product Category',
        field: 'productCategory',
        sortable: true,
        filter: true,
        hide: true,
      },
      {
        headerName: 'Reference User ID',
        field: 'refUserId',
        sortable: true,
        filter: true,
        hide: true,
      },
      {
        headerName: 'Users Used',
        field: 'usersUsed',
        sortable: false,
        filter: false,
        hide: true,
        valueFormatter: params => {
          if (params.value && Array.isArray(params.value)) {
            return params.value.length
          }
          return '0'
        },
      },
      {
        headerName: 'Users Allowed',
        field: 'usersAllowed',
        sortable: false,
        filter: false,
        hide: true,
        valueFormatter: params => {
          if (params.value && Array.isArray(params.value)) {
            return params.value.length
          }
          return '0'
        },
      },
      {
        headerName: 'Expiry Date',
        field: 'expiredAt',
        sortable: true,
        filter: true,
        valueFormatter: params => {
          if (params.value) {
            return moment(params.value).format('LLL')
          }
          return ''
        },
      },
      {
        headerName: 'Notes',
        field: 'notes',
        sortable: true,
        filter: true,
        resizable: true,
        flex: 1,
      },
      {
        headerName: 'Actions',
        field: 'actions',
        sortable: false,
        filter: false,
        minWidth: 200,
        cellRenderer: params => (
          <div className='d-flex gap-2'>
            <Button size='sm' onClick={() => onClickEdit(params.data.id)} className='action-btn'>
              Edit
            </Button>
            <Button size='sm' variant='danger' onClick={() => onClickDelete(params.data.id)} className='action-btn action-btn-delete'>
              Delete
            </Button>
          </div>
        ),
      },
    ],
    [onClickEdit, onClickDelete]
  )

  // Handle selection change
  const handleSelectionChanged = useCallback(
    event => {
      const selectedRows = event.api.getSelectedRows()
      setSelectedCoupons(selectedRows)
      // Handle selection logic here if needed
    },
    [setSelectedCoupons]
  )

  return (
    <DataGrid
      rowData={coupons}
      columnDefs={columnDefs}
      onSelectionChanged={handleSelectionChanged}
      rowSelection={{
        mode: 'multiRow',
        enableClickSelection: false,
        isRowSelectable: rowNode => (rowNode.data ? !rowNode.data.familyName : true),
      }}
      enableSorting={true}
      rowHeight={50}
      enableFiltering={true}
      entityName='coupons'
      className='coupons-data-grid'
      loading={loading}
      defaultColDef={{
        sortable: true,
        filter: true,
        resizable: true,
        minWidth: 100,
      }}
    />
  )
}

export default CouponsDataGrid
